import create from "zustand";
import { ViewMode } from "../models";

type ServiceListItemEditorStore = {
  currentViewMode: ViewMode;
  setCurrentViewMode: (viewMode: ViewMode) => void;
};

const useStore = create<ServiceListItemEditorStore>((set) => ({
  currentViewMode: ViewMode.EditData,
  setCurrentViewMode: (v) =>
    set((state) => ({
      ...state,
      currentViewMode: v,
    })),
}));

export default useStore;
